module.exports = __webpack_public_path__ + "static/media/promo-menos15.8c9725db.png";